import { AD_TYPE_ONE_FOURTH_MIX, CATEGORY_ITEM_TYPE, AD_TYPE_LARGE_BANNER } from "../constants.js";
import { AD_TYPE_ONE_FOURTH_MIX as AD_TYPE_ONE_FOURTH_MIX$1, AD_TYPE_FOUR_CORNERS_CATEGORY, AD_TYPE_ONE_FOURTH, AD_TYPE_FULL, AD_TYPE_HALF, AD_TYPE_ONE_THIRD, AD_TYPE_ONE_SIXTH } from "./constants.js";
const getAdButlerComponentType = (adType, adUnitSize, itemType) => {
  if (adType === AD_TYPE_ONE_FOURTH_MIX) {
    return AD_TYPE_ONE_FOURTH_MIX$1;
  }
  if (itemType === CATEGORY_ITEM_TYPE) {
    if (adType === AD_TYPE_LARGE_BANNER) {
      return AD_TYPE_FOUR_CORNERS_CATEGORY;
    }
    return AD_TYPE_ONE_FOURTH;
  }
  const unitSizeMap = {
    2: AD_TYPE_ONE_SIXTH,
    3: AD_TYPE_ONE_FOURTH,
    4: AD_TYPE_ONE_THIRD,
    6: AD_TYPE_HALF,
    12: AD_TYPE_FULL
  };
  return unitSizeMap[adUnitSize];
};
export {
  getAdButlerComponentType
};
